// Port of api/fuel/app/classes/filter/package/users/user.php
import GeneralPackage from 'offline/filter/package/users/user/package/general'

export default {
	run: function(resultId, local, global, config, filter) {
		var pkg = GeneralPackage.run({}, { id: resultId }, global, config, filter)
		pkg.id = resultId
		return pkg
	}
}
